import './style.css'
import './GamePart.css'
import ReactDOM from 'react-dom/client'
import GamePart from 'GamePart'
import App from 'App'

const root = ReactDOM.createRoot(document.querySelector('#root'))

root.render(
  <App />
)
